import { useState } from 'react';
import { getSelfReferralFile } from 'API/SelfServiceReferrals';
import { pingSelfReferralFiles } from 'API/SelfServiceReferrals/pingFileExisting';
import { SelfReferralPingStatus } from 'Interfaces/SelfServiceReferrals';
import { useIsDesktop } from 'Hooks';
import { downloadFile } from 'Utils';

interface IUseCommitmentFileDownloadOptions {
  fileName: string;
}

export const useCommitmentFileDownload = ({
  fileName,
}: IUseCommitmentFileDownloadOptions) => {
  const isDesktop = useIsDesktop();
  const [isDownloading, setIsDownloading] = useState(false);
  const [viewerBase64, setViewerBase64] = useState<string | null>(null);

  const presentCommitmentFile = async (base64: string) => {
    if (!isDesktop) {
      setViewerBase64(base64);
    } else {
      await downloadFile(base64, '.pdf', fileName);
    }
  };

  const openCommitmentFromBase64 = async (base64: string) => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      await presentCommitmentFile(base64);
    } finally {
      setIsDownloading(false);
    }
  };

  const downloadCommitment = async (selfReferralId: number) => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      const data = await getSelfReferralFile(selfReferralId);
      if (data?.fileContentBase64) {
        await presentCommitmentFile(data.fileContentBase64);
      }
    } finally {
      setIsDownloading(false);
    }
  };

  const downloadCommitmentByRequestId = async (requestId: string) => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      const results = await pingSelfReferralFiles([requestId]);
      const match = results.find((item) => item.ticker === requestId);
      if (
        match?.status === SelfReferralPingStatus.Success &&
        match.fileContentBase64
      ) {
        await presentCommitmentFile(match.fileContentBase64);
      }
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    isDownloading,
    downloadCommitment,
    downloadCommitmentByRequestId,
    openCommitmentFromBase64,
    viewerBase64,
    closeViewer: () => setViewerBase64(null),
  };
};
